import { render, staticRenderFns } from "./FieldDescription.vue?vue&type=template&id=6ed71e12&"
import script from "./FieldDescription.vue?vue&type=script&lang=js&"
export * from "./FieldDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports